export const aciUp = {
    iconName: 'up',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                d: 'M.75 17.19L11.47 6.47a.75.75 0 011.06 0l10.72 10.72',
                stroke: 'currentColor',
                'stroke-width': '1.5',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
